import MyTeamTaskFilters from "./filters";
import TasksListWrapper from "../components/tasks-list";

export default function MyTeamTasks({ status }) {
  return (
    <TasksListWrapper
      status={status}
      basePath="/tasks/my-team"
      storageKeyPrefix="my-team"
      baseFilters={{ assignee: { user: { _neq: "$CURRENT_USER" } } }}
      showAssigneeColumn={true}
      renderFilters={MyTeamTaskFilters}
    />
  );
}
